/* Copyright 2022 SIB Visions GmbH
 *
 * Licensed under the Apache License, Version 2.0 (the "License"); you may not
 * use this file except in compliance with the License. You may obtain a copy of
 * the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied. See the
 * License for the specific language governing permissions and limitations under
 * the License.
 */

/** A map which stores the translations set by the server, also contains default values */
export const translation = new Map()
    .set("Username", "Username")
    .set("Password", "Password")
    .set("Login", "Login")
    .set("Logout", "Logout")
    .set("Settings", "Settings")
    .set("Change password", "Change password")
    .set("Please enter and confirm the new password.", "Please enter and confirm the new password.")
    .set("New Password", "New Password")
    .set("Confirm Password", "Confirm Password")
    .set("The new Password is empty", "The new Password is empty")
    .set("The passwords are different!", "The passwords are different!")
    .set("The old and new password are the same", "The old and new password are the same")
    .set("Change password", "Change password")
    .set("Reset password", "Reset password")
    .set("Lost password", "Lost password")
    .set("Remember me?", "Remember me?")
    .set("Email", "Email")
    .set("Request", "Request")
    .set("Please enter your e-mail address.", "Please enter your e-mail address.")
    .set("The email is required", "The email is required")
    .set("One-time password", "One-time password")
    .set("Please enter your one-time password and set a new password", "Please enter your one-time password and set a new password")
    .set("Please enter your e-mail address.", "Please enter your e-mail address.")
    .set("Save", "Save")
    .set("Reload", "Reload")
    .set("Rollback", "Rollback")
    .set("Information", "Information")
    .set("Error", "Error")
    .set("Warning", "Warning")
    .set("Question", "Question")
    .set("OK", "OK")
    .set("Cancel", "Cancel")
    .set("Yes", "Yes")
    .set("No", "No")
    .set("Change", "Change")
    .set("Session expired!", "Session expired!")
    .set("Take note of any unsaved data, and <u>click here</u> or press ESC to continue.", "Take note of any unsaved data, and <u>click here</u> or press ESC to continue.")
    .set("The authentication code is required", "The authentication code is required")
    .set("Code", "Code")
    .set("Verification", "Verification")
    .set("Please enter your confirmation code.", "Please enter your confirmation code.")
    .set("Waiting for verification.", "Waiting for verification.")
    .set("Matching code", "Matching code")
    .set("Style-Designer", "Style-Designer")
    .set("UI-Designer", "UI-Designer")
    .set("Confirm", "Confirm")
    .set("Details", "Details")
    .set("Cause(s) of failure", "Cause(s) of failure")
    .set("Restart", "Restart")
    .set("Choose", "Choose")
    .set("Upload", "Upload")
    .set("Today", "Today")
    .set("Delete", "Delete")
    .set("Weak", "Weak")
    .set("Medium", "Medium")
    .set("Strong", "Strong")
    .set("Enter a password", "Enter a password")
    .set("About", "About")
    .set("FirstDayOfWeek", "0")
    .set("Weekheader", "Wk")
    .set("era-narrow-BC", "B")
    .set("era-narrow-AD", "A")
    .set("era-abbreviated-BC", "BC")
    .set("era-abbreviated-AD", "AD")
    .set("era-wide-BC", "Before Christ")
    .set("era-wide-AD", "Anno Domini")
    .set("first-quarter-narrow", "1")
    .set("second-quarter-narrow", "2")
    .set("third-quarter-narrow", "3")
    .set("fourth-quarter-narrow", "4")
    .set("first-quarter-abbreviated", "Q1")
    .set("second-quarter-abbreviated", "Q2")
    .set("third-quarter-abbreviated", "Q3")
    .set("fourth-quarter-abbreviated", "Q4")
    .set("first-quarter-wide", "1st quarter")
    .set("second-quarter-wide", "2nd quarter")
    .set("third-quarter-wide", "3rd quarter")
    .set("fourth-quarter-wide", "4th quarter")
    .set("month-narrow-January", "J")
    .set("month-narrow-February", "F")
    .set("month-narrow-March", "M")
    .set("month-narrow-April", "A")
    .set("month-narrow-May", "M")
    .set("month-narrow-June", "J")
    .set("month-narrow-July", "J")
    .set("month-narrow-August", "A")
    .set("month-narrow-September", "S")
    .set("month-narrow-October", "O")
    .set("month-narrow-November", "N")
    .set("month-narrow-December", "D")
    .set("month-abbreviated-January", "Jan")
    .set("month-abbreviated-February", "Feb")
    .set("month-abbreviated-March", "Mar")
    .set("month-abbreviated-April", "Apr")
    .set("month-abbreviated-May", "May")
    .set("month-abbreviated-June", "Jun")
    .set("month-abbreviated-July", "Jul")
    .set("month-abbreviated-August", "Aug")
    .set("month-abbreviated-September", "Sep")
    .set("month-abbreviated-October", "Oct")
    .set("month-abbreviated-November", "Nov")
    .set("month-abbreviated-December", "Dec")
    .set("month-wide-January", "January")
    .set("month-wide-February", "February")
    .set("month-wide-March", "March")
    .set("month-wide-April", "April")
    .set("month-wide-May", "May")
    .set("month-wide-June", "June")
    .set("month-wide-July", "July")
    .set("month-wide-August", "August")
    .set("month-wide-September", "September")
    .set("month-wide-October", "October")
    .set("month-wide-November", "November")
    .set("month-wide-December", "December")
    .set("day-narrow-Monday", "M")
    .set("day-narrow-Tuesday", "T")
    .set("day-narrow-Wednesday", "W")
    .set("day-narrow-Thursday", "T")
    .set("day-narrow-Friday", "F")
    .set("day-narrow-Saturday", "S")
    .set("day-narrow-Sunday", "S")
    .set("day-short-Monday", "Mo")
    .set("day-short-Tuesday", "Tu")
    .set("day-short-Wednesday", "We")
    .set("day-short-Thursday", "Th")
    .set("day-short-Friday", "Fr")
    .set("day-short-Saturday", "Sa")
    .set("day-short-Sunday", "Su")
    .set("day-abbreviated-Monday", "Mon")
    .set("day-abbreviated-Tuesday", "Tue")
    .set("day-abbreviated-Wednesday", "Wed")
    .set("day-abbreviated-Thursday", "Thu")
    .set("day-abbreviated-Friday", "Fri")
    .set("day-abbreviated-Saturday", "Sat")
    .set("day-abbreviated-Sunday", "Sun")
    .set("day-wide-Monday", "Monday")
    .set("day-wide-Tuesday", "Tuesday")
    .set("day-wide-Wednesday", "Wednesday")
    .set("day-wide-Thursday", "Thursday")
    .set("day-wide-Friday", "Friday")
    .set("day-wide-Saturday", "Saturday")
    .set("day-wide-Sunday", "Sunday")
    .set("day-period-narrow-am", "a")
    .set("day-period-narrow-pm", "p")
    .set("day-period-narrow-midnight", "mi")
    .set("day-period-narrow-noon", "n")
    .set("day-period-narrow-morning", "morning")
    .set("day-period-narrow-afternoon", "afternoon")
    .set("day-period-narrow-evening", "evening")
    .set("day-period-narrow-night", "night")
    .set("day-period-abbreviated-am", "AM")
    .set("day-period-abbreviated-pm", "PM")
    .set("day-period-abbreviated-midnight", "midnight")
    .set("day-period-abbreviated-noon", "noon")
    .set("day-period-abbreviated-morning", "morning")
    .set("day-period-abbreviated-afternoon", "afternoon")
    .set("day-period-abbreviated-evening", "evening")
    .set("day-period-abbreviated-night", "night")
    .set("day-period-wide-am", "a.m.")
    .set("day-period-wide-pm", "p.m.")
    .set("day-period-wide-midnight", "midnight")
    .set("day-period-wide-noon", "noon")
    .set("day-period-wide-morning", "morning")
    .set("day-period-wide-afternoon", "afternoon")
    .set("day-period-wide-evening", "evening")
    .set("day-period-wide-night", "night")
    .set("format-day-period-narrow-am", "a")
    .set("format-day-period-narrow-pm", "p")
    .set("format-day-period-narrow-midnight", "mi")
    .set("format-day-period-narrow-noon", "n")
    .set("format-day-period-narrow-morning", "in the morning")
    .set("format-day-period-narrow-afternoon", "in the afternoon")
    .set("format-day-period-narrow-evening", "in the evening")
    .set("format-day-period-narrow-night", "at night")
    .set("format-day-period-abbreviated-am", "AM")
    .set("format-day-period-abbreviated-pm", "PM")
    .set("format-day-period-abbreviated-midnight", "midnight")
    .set("format-day-period-abbreviated-noon", "noon")
    .set("format-day-period-abbreviated-morning", "in the morning")
    .set("format-day-period-abbreviated-afternoon", "in the afternoon")
    .set("format-day-period-abbreviated-evening", "in the evening")
    .set("format-day-period-abbreviated-night", "at night")
    .set("format-day-period-wide-am", "a.m.")
    .set("format-day-period-wide-pm", "p.m.")
    .set("format-day-period-wide-midnight", "midnight")
    .set("format-day-period-wide-noon", "noon")
    .set("format-day-period-wide-morning", "in the morning")
    .set("format-day-period-wide-afternoon", "in the afternoon")
    .set("format-day-period-wide-evening", "in the evening")
    .set("format-day-period-wide-night", "at night")
    .set("Compatibility issue", "Compatibility issue")
    .set("The client and server version are incompatible.", "The client and server version are incompatible.")
    .set("Click here! Or press Escape to retry!", "<u>Click here!</u> Or press Escape to retry!")
    .set("The server is not reachable, trying again in 5 seconds. Retry: ", "The server is not reachable, trying again in 5 seconds. Retry: ")
    .set("The server is not reachable", "The server is not reachable")
    .set("Startup failed!", "Startup failed!")
    .set("Check if the server is available", "Check if the server is available")
    .set("Error occured!", "Error occured!")
    .set("Check the console for more info", "Check the console for more info")
    .set("Server error!", "Server error!")
    .set("Timeout! Couldn't connect to the server.", "Timeout! Couldn't connect to the server.")
    .set("Could not load translation", "Could not load translation")
    .set("An error occured while fetching the translation.", "An error occured while fetching the translation");

export const cssTranslation = new Map();

